module.exports = __webpack_public_path__ + "img/content4.3da4bf3c.png";